import Command, {
  prefix
} from './command'
import utils from '@utils';
import router from '../router';

// 命令操作
export const actions = {
  [Command.INIT] ({
    commit,
    dispatch
  }) {
    // 本地调试
    // const menus = require('/static/html-casarte/casarteSUMEBookMap.json')
    // commit(Mutation.INIT, menus)
    // dispatch(Command.VIDEO_PATH)

    //发布后
    let locationhref=location.href;
    let brand=utils.BIPtools.getBIP(locationhref).brand;
    let industry=utils.BIPtools.getBIP(locationhref).industry;
    let productCode=utils.BIPtools.getBIP(locationhref).productCode;
    let appParams=utils.BIPtools.getBIP(locationhref).appParams;
    let menust;
    let request = new XMLHttpRequest();
    request.open("get", `/app/api/${industry}/casarteSUMEBookMap/${productCode}/static/html-casarte/casarteSUMEBookMap.json`,"true");/*设置请求方法与路径*/
    request.send();
    request.onreadystatechange=function(){
      if(request.readyState==4&&request.status==200){
          menust = JSON.parse(request.response);
          console.log(menust,"menus");
          commit(Mutation.INIT, menust)
          dispatch(Command.VIDEO_PATH)
      }else if(request.status != 200){
        console.log("appParams---:",appParams);
        if(appParams.split("_").length > 1){
          appParams = appParams.split("_")[0];
          console.log("appParams1---1:",appParams);
          console.log('location.href',location.href.split("_")[0]);
          location.href = location.href.split("_")[0];
          //router.push({ path: `/${brand}/${industry}/?${appParams}`});
        }
      }
    }
  },
  [Command.TAB_INDEX_CHANGE] ({
    commit
  }, index) {
    commit(Mutation.TAB_INDEX_CHANGE, index)
  },
  [Command.HEADER_HEIGHT_CHANGE] ({
    commit
  }, height) {
    commit(Mutation.HEADER_HEIGHT_CHANGE, height)
  },
  [Command.VIDEO_PATH] ({
    state,
    commit
  }) {
    let locationhref=location.href;
    let brand=utils.BIPtools.getBIP(locationhref).brand;
    let industry=utils.BIPtools.getBIP(locationhref).industry;
    let productCode=utils.BIPtools.getBIP(locationhref).productCode;
    let data = state.menus.casarteSUMEBookMap
    for (let i = 0; i <data.length; i++) {
      console.log(utils.tool.getVideoPath(data[i]),"path");
      console.log((utils.tool.getVideoPath(data[i]) ? `/app/api/${industry}/casarteSUMEBookMap/${productCode}/static/html-casarte/${utils.tool.getVideoPath(data[i])}` : `http://dms.haier.net/imeWeb/config/REF/casarteSUMEBookMap/AA68H0E0100L/static/html-casarte/object/V005868.mp4`),"path");
      let video_url = utils.tool.getVideoPath(data[i]) ? `/app/api/${industry}/casarteSUMEBookMap/${productCode}/static/html-casarte/${utils.tool.getVideoPath(data[i])}` : ``;
      if(brand === 'haier' && video_url===''){
        video_url = 'https://dms.haier.net/haier.mp4';
      }else if(brand === 'leader' && video_url===''){
        video_url = 'https://dms.haier.net/leader.mp4';
      }else if(brand === 'casarte' && video_url===''){
        video_url = 'https://dms.haier.net/casarte.mp4';
      }else if(video_url===''){
        video_url = 'https://dms.haier.net/imeWeb/config/REF/casarteSUMEBookMap/AA68H0E0100L/static/html-casarte/object/V005868.mp4';
      }

      if(i === 0){
        if(brand === 'haier'){
          video_url = 'https://dms.haier.net/haier.mp4';
        }else if(brand === 'leader'){
          video_url = 'https://dms.haier.net/leader.mp4';
        }else if(brand === 'casarte'){
          video_url = 'https://dms.haier.net/casarte.mp4';
        }
      }
      commit(Mutation.VIDEO_PATH, {
        index: i,
        path: video_url
      })
      
    }
  }
}

// 数据改变命令
const Mutation = {
  INIT: prefix + 'INIT',
  TAB_INDEX_CHANGE: prefix + 'TAB_INDEX_CHANGE',
  HEADER_HEIGHT_CHANGE: prefix + 'HEADER_HEIGHT_CHANGE',
  VIDEO_PATH: prefix + 'VIDEO_PATH'
}

// 数据改变操作
export const mutations = {
  [Mutation.INIT] (state, data) {
    state.menus = data
  },
  [Mutation.TAB_INDEX_CHANGE] (state, data) {
    state.tabIndex = data
  },
  [Mutation.HEADER_HEIGHT_CHANGE] (state, data) {
    state.headerHeight = data
  },
  [Mutation.VIDEO_PATH] (state, data) {
    if (data.index === 0) {
      state.video0 = data.path
    }else if (data.index === 1) {
      state.video1 = data.path
    } else if (data.index === 2) {
      state.video2 = data.path
    } else if (data.index === 3) {
      state.video3 = data.path
    }  else {
      state.video4 = data.path
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/handle.js